export const ANIMATION_DURATION = 300;
export const DISABLED_GREY = '#686868';
export const WHITE = '#FFFFFF';
export const CUBE_BREAKPOINT_SMALL = 330;
export const CUBE_BREAKPOINT_BIG = 480;
